module.exports = __webpack_public_path__ + "img/logo.73671fc0.png";